const initialState = [
  {
    id: 'r1',
    name: 'Actualités',
    color: '#006E39',
  },
  {
    id: 'r2',
    name: 'Carte MyPMU',
    color: '#00A0C8',
  },
  {
    id: 'r3',
    name: 'Concepts',
    color: '#F46709',
  },
  {
    id: 'r4',
    name: 'Pour aller plus loin',
    color: '#E3097D',
  },
  {
    id: 'r5',
    name: 'Prestago',
    color: '#8CD23F',
  },
  {
    id: 'r6',
    name: 'Autres',
    color: '#6244EE',
  },
];


export default (state = initialState) => (state);



// WEBPACK FOOTER //
// ./book/src/category/categoriesDucks.js